export interface AuthScopeToken {
  authScopeKey: string;
  generation: number;
}

const generationByKey = new Map<string, number>();

/**
 * Increments the monotonic auth generation for the given scope key.
 * Call only from ConnectorOAuthCoordinatorProvider on auth boundaries.
 */
export function advanceAuthScopeGeneration(authScopeKey: string): number {
  const next = (generationByKey.get(authScopeKey) ?? 0) + 1;
  generationByKey.set(authScopeKey, next);
  return next;
}

/** Captures the current auth generation for later staleness checks. */
export function captureAuthScope(authScopeKey: string | null): AuthScopeToken | null {
  if (!authScopeKey) return null;
  return {
    authScopeKey,
    generation: generationByKey.get(authScopeKey) ?? 0,
  };
}

/** Returns true when the token still matches the live auth generation. */
export function isCurrentAuthScope(token: AuthScopeToken | null): boolean {
  if (!token) return false;
  return (generationByKey.get(token.authScopeKey) ?? 0) === token.generation;
}
